import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "limiter",
})
export class LimiterPipe implements PipeTransform {
  constructor() {}

  transform(current: number, max: number) {
    return "(" + current.toString() + " av " + max.toString() + ")";
  }
}
